export default {
  'Login': 'Connexion',
  'Register': 'Inscription',
  'Logout': 'Déconnexion',
  'Email': 'Adresse e-mail',
  'Password': 'Mot de passe',
  'Confirm Password': 'Confirmer le mot de passe',
  'Forgot password?': 'Mot de passe oublié ?',
  'Don\'t have an account?': 'Vous n\'avez pas de compte ?',
  'Already have an account?': 'Vous avez déjà un compte ?',
  'Sign up': 'S\'inscrire',
  'Sign in': 'Se connecter',
  'Create Account': 'Créer un compte',
  'Join Now': 'Rejoindre maintenant',
  'Your email address': 'Votre adresse e-mail',
  'Your password': 'Votre mot de passe',
  'Remember me': 'Se souvenir de moi',
  'Enter your email': 'Entrez votre adresse e-mail',
  'Enter your password': 'Entrez votre mot de passe',
  'Seedphrase': 'Phrase de récupération',
  'Create a seedphrase for anonymous login': 'Créez une phrase de récupération pour une connexion anonyme',
  'Login with Seedphrase': 'Connexion avec phrase de récupération',
  'Enter at least 6 words separated by spaces': 'Entrez au moins 6 mots séparés par des espaces',
  'Use seedphrase instead of password': 'Utiliser une phrase de récupération au lieu d\'un mot de passe',
  'Your seedphrase has been created': 'Votre phrase de récupération a été créée. Veuillez la conserver en lieu sûr.',
  'Seedphrase must contain at least 6 words': 'La phrase de récupération doit contenir au moins 6 mots',
  'Name': 'Nom',
  'Your name': 'Votre nom',
  'Create Anonymous Account': 'Créer un compte anonyme',
  'Login Anonymously': 'Connexion anonyme',
  'Email & Password': 'Email et mot de passe',
  'Anonymous (Seedphrase)': 'Anonyme (Phrase de récupération)',
  'Create an account with your email': 'Créez un compte avec votre email',
  'Create an anonymous account with a seedphrase': 'Créez un compte anonyme avec une phrase de récupération',
  'Sign in to your account': 'Connectez-vous à votre compte',
  'Create your account': 'Créez votre compte',
  'Confirm your password': 'Confirmez votre mot de passe',
  'I agree to the': 'J\'accepte les',
  'Terms of Service': 'Conditions d\'utilisation',
  'and': 'et',
  'Privacy Policy': 'Politique de confidentialité',
  'Loading...': 'Chargement...',
  'Reset your password': 'Réinitialiser votre mot de passe',
  'Enter your email address and we\'ll send you a link to reset your password.': 'Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
  'Send reset link': 'Envoyer le lien de réinitialisation',
  'Cancel': 'Annuler',
  'Sending...': 'Envoi en cours...',
  'Account type': 'Type de compte',
  'Client': 'Client',
  'Escort': 'Escort',
  'Select your account type': 'Sélectionnez votre type de compte',
  'Choose your role': 'Choisissez votre rôle',
  'auth.login.title': 'Connexion',
  'auth.login.description': 'Connectez-vous à votre compte pour accéder aux fonctionnalités exclusives et vous connecter avec d\'autres',
  'auth.login.agree_terms_prefix': 'En vous connectant, vous acceptez nos',
  'auth.login.terms_link': 'Conditions d\'utilisation',
  'auth.login.and': 'et',
  'auth.login.privacy_link': 'Politique de confidentialité',
  'auth.register.title': 'Rejoignez maintenant',
  'auth.register.description': 'Créez votre compte pour accéder aux fonctionnalités exclusives et vous connecter avec d\'autres',
  'auth.register.button': 'S\'inscrire',
  'auth.register.create_title': 'Créez votre compte',
  'auth.register.tab_email': 'Email & Mot de passe',
  'auth.register.tab_seedphrase': 'Anonyme (Phrase secrète)',
  'auth.register.email_tab_title': 'Créer un compte avec votre email',
  'auth.register.seedphrase_tab_title': 'Créer un compte anonyme avec une phrase secrète',
  'auth.register.already_have_account': 'Vous avez déjà un compte ?',
  'auth.register.sign_in_link': 'Se connecter',
  'auth.register.name_label': 'Nom',
  'auth.register.name_placeholder': 'Votre nom',
  'auth.register.email_label': 'Email',
  'auth.register.email_placeholder': 'Votre adresse email',
  'auth.register.password_label': 'Mot de passe',
  'auth.register.password_placeholder': 'Votre mot de passe',
  'auth.register.confirm_password_label': 'Confirmer le mot de passe',
  'auth.register.confirm_password_placeholder': 'Confirmez votre mot de passe',
  'auth.register.agree_terms_prefix': 'J\'accepte les',
  'auth.register.terms_link': 'Conditions d\'utilisation',
  'auth.register.and': 'et',
  'auth.register.privacy_link': 'Politique de confidentialité',
  'auth.register.create_button': 'Créer le compte',
  'auth.register.account_type_label': 'Type de compte',
  'auth.register.account_type_client': 'Client',
  'auth.register.account_type_escort': 'Escorte'
};
